var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 1.3335V4.00016M4.33333 1.3335V4.00016M1 6.66683H13M2.33333 2.66683H11.6667C12.403 2.66683 13 3.26378 13 4.00016V13.3335C13 14.0699 12.403 14.6668 11.6667 14.6668H2.33333C1.59695 14.6668 1 14.0699 1 13.3335V4.00016C1 3.26378 1.59695 2.66683 2.33333 2.66683Z",
    stroke: "#A3A5AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.79e7c4da77ce7376dfb04d9f140b3617.svg";
export { ForwardRef as ReactComponent };